export const NotFound = () => {
  return (
    <div>
      <h1>404</h1>
      <p>Oops! The page you're looking for could not be found.</p>
    </div>
  );
};
